/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Priority_ConfirmInputs */



/**
* | output |
* | --- |
* | "Save Priority" |
*
* @param {Explorer_Info_Priority_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_priority_confirm = /** @type {((inputs?: Explorer_Info_Priority_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Priority_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Save Priority")
	if (locale === "de") return /** @type {LocalizedString} */ ("Save Priority")
	if (locale === "it") return /** @type {LocalizedString} */ ("Save Priority")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Save Priority")
	if (locale === "es") return /** @type {LocalizedString} */ ("Save Priority")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Save Priority")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Save Priority")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Save Priority")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Save Priority")
	return /** @type {LocalizedString} */ ("Save Priority")
});